import React from "react"
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

import * as classes from "./top_banner.module.scss"

const BannerWrapperCustomImg = ({largeBgImg, nonlargeBgImg, children}) => {
  const breakpoints = useBreakpoint();
  
  return (
    <>
    <div
          className={`text-white bg-cover bg-no-repeat ${classes.background_wrapper_custom_img}`}
          style={{ backgroundImage: `${breakpoints.l ? `url("${largeBgImg}")`:`url("${nonlargeBgImg}")`}` }}
    >
          {children}
    </div>
      
    </>
  )
}

export default BannerWrapperCustomImg;
